import React from 'react';
import map from "lodash/map";
import { connect } from 'react-redux';
import {
    editDestination, postDestination, postDestinationD0,
    postDestinationD6
} from "../../../../actions/app/mpt/weeks";

import './Destinations.css';

class Destinations extends React.Component {
    constructor(props) {
        super();
        this.state = {
            modif: false,
            club: props.d.value ? props.d.value.clubId : '',
            quotation: props.d.value ? props.d.value.quotation : '',
        }
    }

    submitEditDestination(edit, weekId, cardId, dest) {
        const { dispatch } = this.props;
        const { quotation, club } = this.state;
        if (edit) {
            if (club !== 'Not specified' && quotation) {
                dispatch(editDestination({clubId: club === '' && edit.id === 'd6' ? 'mpt_club_0' : club, quotation}, weekId, cardId, dest))
                this.setState({ modif: false });
            }
        } else {
            if (dest === 'd0' && club && quotation) {
                dispatch(postDestinationD0({clubId: club, quotation}, weekId, cardId));
                this.setState({ modif: false });
            }
            else if (dest === 'd6' && quotation) {
                dispatch(postDestinationD6({ quotation} , weekId, cardId));
                this.setState({ modif: false });
            }
            else if (club && quotation) {
                dispatch(postDestination({clubId: club, quotation}, weekId, cardId))
                this.setState({ modif: false });
            }
        }
    }

    render() {
        const { d, clubs, week, card } = this.props;
        const { club, quotation, modif } = this.state;
        return (
            <div  className="text-center destinations">
                <p>{d.id === 'd0' ? 'il reste' : d.id}</p>
                {
                    d.id !== 'd6' ? (
                    <select
                        className="form-control"
                        value={club}
                        onChange={(t) => this.setState({ modif: true, club: t.target.value })}
                    >
                        <option>Not specified</option>
                        {
                            map(clubs, club => {
                                return (
                                    <option
                                        value={club.id}
                                        key={club.id}
                                    >
                                        {club.clubName}
                                    </option>
                                )
                            })
                        }
                    </select>) : (
                        <p>Autre</p>
                    )
                }
                <input
                    className="text-center"
                    placeholder="quotation"
                    value={quotation}
                    onChange={(t) => this.setState({ modif: true, quotation: t.target.value })}
                />
                <div>
                    <button
                        id={`button${card.id}.${d.id}`}
                        className={modif ? 'btn-warning buttonDestination' :'btn-success buttonDestination'}
                        onClick={() => this.submitEditDestination(d.value, week.id, card.id, d.id)}
                    >
                        {d.value ? 'Modify' : 'Add'}
                    </button>
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({ state }),
    dispatch => ({ dispatch }),
)(Destinations);



// WEBPACK FOOTER //
// ./src/pages/MPT/Creation/Destinations/index.js